import { observer } from "mobx-react-lite"
import { useEffect, useRef, useState } from "react";
import "../../styles/multirange.css";
import Clicker from "./Clicker";
import HiddenValueOfRange from "./MicroUI/hiddenValueOfRange";
import { ReactComponent as RemoveIcon } from "../../images/icons/contextRemove.svg";

const MultiRangeSlider = ({ ranges, setRangesArr, saveRanges, onDelete, min, max, disabled }) => {
    
    const sliderRef = useRef(null);
    const rangesRef = useRef(ranges);
    const saveTimeoutRef = useRef(null);
    // const [margin, setMargin] = useState(20);
    const [margin, setMargin] = useState(80);
    
    useEffect(() => {
        rangesRef.current = ranges;
    }, [ranges]);

    const handleMouseMove = (e, index, type) => {
        if (disabled) return;
        if (!sliderRef.current) return;
        e.preventDefault();
        const rect = sliderRef.current.getBoundingClientRect();
        const percent = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        const value = Math.round(min + percent * (max - min));
        
        let newRanges = JSON.parse(JSON.stringify(ranges));
        if (type === "start") {
            if (index > 0 && value <= newRanges[index - 1].end) return;
            if (value > newRanges[index].end) return;
            newRanges[index].start = value;
        } else {
            if (index < newRanges.length - 1 && value >= newRanges[index + 1].start) return;
            // if (value < newRanges[index].start && newRanges[index].hideStart != true) return;
            if (value < newRanges[index].start) return;
            newRanges[index].end = value;
            // if (newRanges[index].end < newRanges[index].end) newRanges[index].start = value;
        }
        if (newRanges[index].end == newRanges[index].start) newRanges[index].hideStart = true;
        else newRanges[index].hideStart = false; 

        setRangesArr(newRanges, index);
    };
    const handleMouseDown = (index, type) => {
        const onMouseMove = (e) => handleMouseMove(e, index, type);
        const onMouseUp = () => {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);

            if (disabled) return;
            // if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
            // saveTimeoutRef.current = setTimeout(() => {
                saveRanges(rangesRef.current[index]);
            // }, 300);
        };
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    };

    return (
        <div className="multi-range-slider">
            <div className="slider-track" ref={sliderRef} style={{ marginBottom: `${margin}px` }}>
                {ranges && ranges.length > 0 && ranges.map((range, index) => (
                    <div
                        key={index}
                        className="range"
                        style={{ left: `${((range.start - min) / (max - min)) * 100}%`, width: `${((range.end - range.start) / (max - min)) * 100}%` }}
                        // onMouseEnter={() => setMargin(80)}
                        // onMouseLeave={() => setMargin(20)}
                    >
                        <div
                            className={`handle left${ranges[index].hideStart ? " hide" : ""}`}
                            onMouseDown={() => handleMouseDown(index, "start")}
                            style={{ left: "0%" }}
                            ><div className="value">{ranges[index].start} чел.</div></div>
                        <div
                            className="handle right"
                            onMouseDown={() => handleMouseDown(index, "end")}
                            style={{ right: "0%" }}
                        ><div className="value">{ranges[index].end} чел.</div></div>
                        <HiddenValueOfRange range={ranges[index]}/>
                        <div className="clickerZone">
                            <Clicker
                                value={ranges[index].percent}
                                setValue={(newValue) => {
                                    if (disabled) return;
                                    let newRanges = [...ranges];
                                    newRanges[index] = { 
                                        ...newRanges[index],
                                        start: newRanges[index].start, 
                                        end: newRanges[index].end, 
                                        percent: newValue, 
                                    }
                                    setRangesArr(newRanges, index);
                                    saveRanges(newRanges[index]);
                                }}
                                step={1}
                                isDecimal={true}
                                max={100}
                            />
                            <button className="redButton" onClick={() => !disabled && onDelete(index)}><RemoveIcon/> Удалить</button>
                        </div>
                    </div>
                ))}
            </div>
            {/* <button onClick={addRange}>Добавить диапазон</button> */}
        </div>
    );
}

export default observer(MultiRangeSlider);
